export const createColumnsFeedbackMessage = () => [];

export const createFeedbackMessageFilters = () => [];
